//商品情報のタブ切り替え
const tabLists = document.querySelectorAll('.p-productInfo__tab');
tabLists.forEach(function(tabList) {
  const tabs = Array.from(tabList.querySelectorAll('li'));
  const contents = Array.from(tabList.closest('.p-productInfo').querySelectorAll('.p-productInfo__content > *'));
  tabs.forEach(function(li, index) {
    li.addEventListener('click', function() {
      if (li.classList.contains('active')) return;
      tabList.querySelector('li.active')?.classList.remove('active');
      li.classList.add('active');
      contents.forEach(function(content) { content.style.display = 'none'; });
      if (contents[index]) contents[index].style.display = 'block';
    });
  });
});

//カテゴリアコーディオン
document.querySelectorAll('.js-toggle').forEach(function(toggle) {
  const content = toggle.nextElementSibling;
  toggle.addEventListener('click', function() {
    if (toggle.classList.contains('opened')) {
      content.style.maxHeight = '0';
      toggle.classList.remove('opened');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.classList.add('opened');
    }
  });
});

//カテゴリスクロールプログレスバー
document.querySelectorAll('.p-catSection__list').forEach(function(list) {
  const bar = list.nextElementSibling?.querySelector('.p-catSection__progress__bar');
  if (!bar) return;
  list.addEventListener('scroll', function() {
    const ratio = list.scrollLeft / (list.scrollWidth - list.clientWidth);
    bar.style.width = (ratio * 100) + '%';
  });
});

//MVスライダー
const homeSliders = document.querySelectorAll('.p-homeSlide__slide');
if(homeSliders){
  homeSliders.forEach(function(slider){
    homeSlide = new Splide(slider,{
      arrows: false,
      autoplay: true,
      autoWidth: true,
      focus: 'center',
      interval: 4000,
      speed: 700,
      type: 'loop'
    });
    homeSlide.mount();
  });
}